<template>
  <div
    class="h-full flex flex-col items-center justify-center cursor-pointer odd w-full"
    :class="[
      favLayout && 'favLClass',
      isSelected && favLayout && 'favLayActive',
      isSelected ? 'bg-[var(--color-grey9)]' : 'hover:bg-[var(--color-white15)]'
    ]"
    @click="toggle"
    v-if="odd && odd.st != 2"
  >
    <p
      class="text-[13px]"
      :class="[
        favLayout ? 'w-full flex items-center justify-between px-2' : '',
        odd.st == 3 && 'text-neutral-400 flex items-center justify-between',
        (odd.st == 0 || odd.st == 1) && 'text-[var(--color-yellow1)]',
        isSelected && '!text-[var(--color-primary1)]'
      ]"
    >
      <span
        v-if="withName"
        class="mr-2"
        :class="[
          favLayout ? ' whitespace-nowrap' : '',
          (odd.st == 1 || odd.st == 0) ? 'text-white whitespace-nowrap' : '',
        ]"
      >
        {{ name }}
      </span>

      <img
        v-if="odd.st == 3"
        src="/lock2.svg"
        class="h-4 w-4 mb-1"
        alt="Locked"
      />

      <span
        v-else
        class="text-[13px]"
        :class="[oddClasses, hasChanged ? 'font-bold' : '', favLayout ? '' : '']"
      >
        {{ getOddType == 'p' ? toFixedTwo(odd[getOddType]) : odd[getOddType] }}
      </span>
    </p>
  </div>
</template>

<script setup>
import { computed, ref, watch } from "vue";
import { toFixedTwo, safeTranslate } from "@/helpers";
import { useI18n } from "vue-i18n";
import { useJackpotStore } from "@/stores/jackpot";

const props = defineProps({
  odd: Object,
  eventId: Number | String,
  favLayout: { type: Boolean, default: false },
  withName: { type: Boolean, default: false },
  oddClasses: String
});

const emit = defineEmits(["jackpot-odd"]);

const jackpot = useJackpotStore();
const { t, te } = useI18n();

const name = computed(() => safeTranslate("selections", props.odd.n, t, te));
const hasChanged = ref(false);
const getOddType = "p"; 

watch(
  () => props.odd,
  () => {
    hasChanged.value = true;
    setTimeout(() => (hasChanged.value = false), 800);
  },
  { deep: true }
);

const isSelected = computed(() => {
  const eventSelections = jackpot.selections[props.eventId]
  if (!eventSelections) return false

  return !!eventSelections[props.odd.i]
})

const toggle = () => {
  jackpot.toggleOdd(props.eventId, props.odd)
  emit("jackpot-odd", { odd: props.odd, eventId: props.eventId })
}
</script>

<style scoped>
.odd {
  transition: 0.15s ease;
}
.favLClass {
  @apply bg-neutral-900 text-yellow-400 flex justify-between w-full;
}
.favLayActive {
  @apply ring-2 ring-[var(--color-primary1)] bg-[var(--color-grey9)];
}
</style>
